import React from "react";

const UIModalContext = React.createContext();

export class UIModalProvider extends React.Component {
  handleConfirm(message) {
    return window.confirm(message);
  }

  render() {
    return (
      <UIModalContext.Provider
        value={{
          confirm: this.handleConfirm
        }}
      >
        {this.props.children}
      </UIModalContext.Provider>
    );
  }
}

export const UIModalConsumer = UIModalContext.Consumer;
